import * as React from 'react';
import { CoreTooltip } from '../internal/WixUiCoreComponents/components/CoreTooltip';
import { getArrowByPlacement } from './Arrows';
import { st, classes } from './Tooltip.st.css';
import { TooltipSkin } from './types';
const customArrow = (placement, arrowProps) => {
    const ArrowSvg = getArrowByPlacement(placement);
    return (React.createElement("div", { className: classes.tpaArrow, ...arrowProps },
        React.createElement(ArrowSvg, null)));
};
const Tooltip = (props) => {
    const { className, skin = TooltipSkin.Standard, maxWidth = 240, ...rest } = props;
    return (React.createElement(CoreTooltip, { className: st(classes.root, { skin: props.skin }, className), timeout: { enter: 120, exit: 80 }, customArrow: customArrow, maxWidth: maxWidth, ...rest }));
};
Tooltip.displayName = 'Tooltip';
export { Tooltip };
//# sourceMappingURL=Tooltip.js.map